import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";

export const alertsList = createRemoteArrayResourceReducer("ALERTS_LIST");
